import { POST,postFile } from "../../index";

export const queryBatteryPage = (param) => POST("/v1/BatteryStatusController/queryPage", param);
export const addBattery = (param) => POST("/v1/BatteryStatusController/addBattery", param);
export const updateBattery = (param) => POST("/v1/BatteryStatusController/updateBattery", param);
export const deleteBatteryById = (param) => POST("/v1/BatteryStatusController/deleteBatteryById", param);
export const batteryAppropriate = (param) => POST("/v1/BatteryStatusController/batteryAppropriate", param);
export const batteryBinding = (param) => POST("/v1/BatteryStatusController/batteryBinding", param);
export const uploadBattery = (param) => postFile("/v1/getExportExcel/uploadBattery", param);

export const queryBatteryStatusPage = (param) => POST("/v1/BatteryStatusController/queryBatteryStatusPage", param);
export const queryBatteryInfo = (param) => POST("/v1/BatteryStatusController/queryBatteryByBatteryNumber", param);
export const queryBatteryChargeInfo = (param) => POST("/v1/BatteryStatusController/queryBatteryUseByBatteryNumber", param);
export const queryBatteryPower = (param) => POST("/v1/BatteryStatusController/queryBatteryPower", param);
